import XlX2FlashDealModal from 'src/components/Modals/XlX2FlashDealModal.svelte';
import { PROMOTIONS } from 'src/constants';
import { isRepoUser } from 'src/helpers/user_server_conditions';
import { profile_data } from 'src/stores/account/user';
import { get } from 'svelte/store';

export const XlX2FlashDealModalConfig = (forceShow = false) => {
	return {
		id: 'xlX2FlashDeal',
		component: XlX2FlashDealModal,
		props: {
			showModal: true,
		},
		rules: [
			{
				check: () => {
					const now = new Date().getTime();
					const profileData = get(profile_data);
					const hasBeenSeen = !!profileData?.promotions?.xlX2FlashDeal;
					const isEligible = !!profileData?.aep?.xlx2?.ts || import.meta.env.DEV;

					return (
						isEligible &&
						now >= PROMOTIONS.XL_X2_FLASH_DEAL.START_DATE &&
						now < PROMOTIONS.XL_X2_FLASH_DEAL.END_DATE &&
						(!hasBeenSeen || forceShow)
					);
				},
				expected: true,
			},
		],
	};
};
